export const ROUTES = {
  ROOT: '/',
  LOGIN: '/login',
  SITES: '/sites',
  SITES_INFO: '/site-information',
  CP: '/Cp',
  AUDIT: '/audit'
};
